import { get } from '../../infra/rest';
import requestConfig from '../config/request';
import { WabaLevelUserPermissionsResponse } from '../typings/waba-level-permission';
import { urlCreator } from '../utils/url-helpers';

export const getWabaLevelUserPermissions = async (): Promise<WabaLevelUserPermissionsResponse> => {
  const url = urlCreator({
    baseUrl: `${requestConfig.aiBotBaseUrl}/v1/waba/roles-and-permissions`,
  });

  return get<WabaLevelUserPermissionsResponse>(url, undefined, true, false, true, false, true);
};

export default getWabaLevelUserPermissions;
